import { Link } from "react-router-dom";
import { ArrowRight, BedDouble, Check } from "lucide-react";
import { useLang } from "@/i18n";
import { photos, rooms } from "@/data/site";
import { PageHero } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { CtaBanner } from "@/components/site/CtaBanner";
import { SEO } from "@/components/site/SEO";

export default function Camere() {
  const { t } = useLang();
  return (
    <>
      <SEO title={t.pages.camere.seo} description={t.pages.camere.desc} path="/camere" />
      <PageHero image={photos.matrimoniale} eyebrow={t.pages.camere.eyebrow} title={t.pages.camere.title} testid="camere-hero" />

      <section className="py-16 sm:py-24" data-testid="rooms-list">
        <div className="mx-auto max-w-7xl space-y-20 px-4 sm:px-6 lg:px-8">
          {rooms.map((room, i) => {
            const r = t.rooms[room.id];
            const flip = i % 2 === 1;
            return (
              <Reveal key={room.id}>
                <article data-testid={`room-section-${room.id}`} className={`grid items-center gap-10 lg:grid-cols-2 ${flip ? "lg:[&>*:first-child]:order-2" : ""}`}>
                  <div className="grid gap-4">
                    <img src={room.gallery[0]} alt={r.name} loading="lazy" className="h-80 w-full rounded-3xl object-cover shadow-xl sm:h-96" />
                    {room.gallery[1] && (
                      <img src={room.gallery[1]} alt={`${r.name} — dettaglio`} loading="lazy" className="h-36 w-full rounded-2xl object-cover shadow-lg" />
                    )}
                  </div>
                  <div>
                    <span className="inline-flex items-center gap-2 rounded-full bg-sand-deep px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-terracotta">
                      <BedDouble size={15} /> {r.beds}
                    </span>
                    <h2 className="mt-4 font-serif text-3xl font-semibold text-ink sm:text-4xl">{r.name}</h2>
                    <p className="mt-4 max-w-lg text-base leading-relaxed text-ink-muted sm:text-lg">{r.d}</p>
                    <ul className="mt-6 space-y-2.5">
                      {r.features.map((f) => (
                        <li key={f} className="flex items-center gap-2.5 text-sm font-semibold text-ink">
                          <span className="flex h-6 w-6 items-center justify-center rounded-full bg-olive/15 text-olive"><Check size={14} /></span>
                          {f}
                        </li>
                      ))}
                    </ul>
                    <Link to="/prenota" data-testid={`room-cta-${room.id}`} className="mt-8 inline-flex items-center gap-2 rounded-full bg-mare px-6 py-3 text-sm font-bold text-sand transition-all duration-200 hover:bg-mare-light hover:-translate-y-0.5">
                      {t.hero.cta2} <ArrowRight size={16} />
                    </Link>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </section>

      <CtaBanner />
    </>
  );
}
